import Tools from './tools';

export default class Nav {
  constructor() {
    // Nav

    this.burgerMenu();
    this.burgerMenuAlt();
    this.burgerSideMenu();

    if (window.innerWidth < 1024) {
      this.menuMobile();
    }
  }

  burgerMenu() {
    const btn = document.querySelector('header .top .burger-menu');
    if (btn) {
      btn.addEventListener('click', () => {
        btn.classList.toggle('open');
        document.querySelector('header .main-menu').classList.toggle('open');
        document.querySelector('header .top .right').classList.remove('open');
        document.querySelector('header .top .burger-menu-alt').classList.remove('open');
        document.querySelector('header .menu_lateral').classList.remove('open');
        document.querySelector('header .top .burger-side-menu').classList.remove('open');
      });
    }
  }

  burgerMenuAlt() {
    const btn = document.querySelector('header .top .burger-menu-alt');
    if (btn) {
      btn.addEventListener('click', () => {
        btn.classList.toggle('open');
        document.querySelector('header .top .right').classList.toggle('open');
        document.querySelector('header .main-menu').classList.remove('open');
        document.querySelector('header .top .burger-menu').classList.remove('open');
        document.querySelector('header .menu_lateral').classList.remove('open');
        document.querySelector('header .top .burger-side-menu').classList.remove('open');
      });
    }
  }

  burgerSideMenu() {
    const btn = document.querySelector('header .top .burger-side-menu');
    if (btn) {
      btn.addEventListener('click', () => {
        btn.classList.toggle('open');
        document.querySelector('header .menu_lateral').classList.toggle('open');
        document.querySelector('header .main-menu').classList.remove('open');
        document.querySelector('header .top .burger-menu').classList.remove('open');
        document.querySelector('header .top .right').classList.remove('open');
        document.querySelector('header .top .burger-menu-alt').classList.remove('open');
      });
    }
  }

  menuMobile() {
    const links = document.querySelectorAll('.menu-item-has-children > a, .menu-item-has-children > span');
    if (links.length > 0) {
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          link.parentElement.classList.toggle('open');

          if (link.parentElement.classList.contains('open')) {
            Tools.zeroToAuto( link.nextElementSibling );
          } else {
            Tools.autoToZero( link.nextElementSibling );
          }
        });
      });
    }
  }
}